import { ChangeLanguagaInput } from './dto/changeLanguageInput';
import { CreateOrUpdateUserInput } from './dto/createOrUpdateUserInput';
import { EntityDto, ICreationAudited } from '../../services/dto/entityDto';
import { GetAllUserOutput } from './dto/getAllUserOutput';
import { PagedResultDto } from '../../services/dto/pagedResultDto';
import { PagedUserResultRequestDto } from "./dto/PagedUserResultRequestDto";
import { UpdateUserInput } from './dto/updateUserInput';
import http from '../httpService';
import { UserServiceProxy } from '../serviceProxy';
class UserService {
  public async create(createUserInput: CreateOrUpdateUserInput) {
    let result = await http.post('api/services/DigitalLogisticSystem/User/Create', createUserInput);
    return result.data;
  }

  public async update(updateUserInput: UpdateUserInput) {
    let result = await http.put('api/services/DigitalLogisticSystem/User/Update', updateUserInput);
    return result.data;
  }

  public async delete(entityDto: EntityDto) {
    let result = await http.delete('api/services/DigitalLogisticSystem/User/Delete', { params: entityDto });
    return result.data;
  }

  public async unDisabledUser(entityDto: EntityDto) {
    let result = await http.post('api/services/DigitalLogisticSystem/User/UnDisabledUser', entityDto);
    return result.data;
  }

  public async getRoles() {
    let result = await http.get('api/services/DigitalLogisticSystem/User/GetRoles');
    return result.data.items;
  }

  public async changeLanguage(changeLanguageInput: ChangeLanguagaInput) {
    let result = await http.post('api/services/DigitalLogisticSystem/User/ChangeLanguage', changeLanguageInput);
    return result.data;
  }

  public async get(entityDto: EntityDto): Promise<CreateOrUpdateUserInput> {
    let result = await http.get('api/services/DigitalLogisticSystem/User/Get', { params: entityDto });
    return result.data;
  }

  public async getAll(pagedFilterAndSortedRequest: PagedUserResultRequestDto): Promise<PagedResultDto<GetAllUserOutput>> {
    let result = await http.get('api/services/DigitalLogisticSystem/User/GetAll', { params: pagedFilterAndSortedRequest });
    return result.data;
  }

  //替换creatorUserId为creatorName
  public async ReplaceCreatorUserIdByName(items: ICreationAudited[], antherUserIdPropNames: string[] = []) {
    const userIdPropNames = new Set([...antherUserIdPropNames, 'creatorUserId']);
    //获取所需userid和name
    const userIds = new Set<number>();
    for (const item of items) {
      for (const userIdPropName of userIdPropNames) {
        const userId = item[userIdPropName];
        userId && userIds.add(userId);
      }
    }
    var userid_names = (await new UserServiceProxy().getUserIdAndNamesByUserIds([...userIds]))
      .reduce((pre, user) => {
        pre[user.userId] = user.name;
        return pre;
      }, {});
    //替换userid为name
    for (const item of items) {
      for (const userIdPropName of userIdPropNames) {
        const userId = item[userIdPropName];
        item[userIdPropName] = userid_names[userId] || userId;
      }
    }
  }


  
  public async excelUser(pagedFilterAndSortedRequest: PagedUserResultRequestDto): Promise<string> {
    let result = await http.get('api/services/DigitalLogisticSystem/User/ExcelUser', { params: pagedFilterAndSortedRequest });
    return result.data;
  }
}

export default new UserService();
